let setNumber = (s) => {
  let type = 0
  if (/[^0-9\.]/.test(s))
    return "0";
  if (s == null || s == "")
    return "0";
  s = s.toString().replace(/^(\d*)$/, "$1.");
  s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
  s = s.replace(".", ",");
  var re = /(\d)(\d{3},)/;
  while (re.test(s))
    s = s.replace(re, "$1,$2");
  s = s.replace(/,(\d\d)$/, ".$1");
  if (type === 0) {// 不带小数位(默认是有小数位)
    var a = s.split(".");
    if (a[1] === "00") {
      s = a[0];
    }
  }
  return s;
}
let setStatus = (status)=> {
  let statusText = '';
  switch (status) {
    case 1:
      statusText = "待付款";
      break;
    case 2:
      statusText = "待发货";
      break;
    case 3:
      statusText = "已发货";
      break;
    case 4:
      statusText = "已完成";
      break;
  }
  return statusText;
}
// 转换utc时间

let changeTime = (time)=> {
  if(!time){
    return '-';
  }
  function formatFunc(str) {    //格式化显示
    return str > 9 ? str : '0' + str
  }
  var date2 = new Date(time);     //这步是关键
  var year = date2.getFullYear();
  var mon = formatFunc(date2.getMonth() + 1);
  var day = formatFunc(date2.getDate());
  var hour = date2.getHours();
  // hour = hour>=12?hour-12:hour;
  hour = formatFunc(hour);
  var min = formatFunc(date2.getMinutes());
  let milli = formatFunc(date2.getSeconds());
  var dateStr = year+'-'+mon+'-'+day+' '+hour+':'+min + ':' + milli;
  return dateStr;
}
export default {setNumber, setStatus, changeTime}